module.exports = __webpack_public_path__ + "static/005-37c6983f6f48f970ab7ba5aba712470a.png";